import { render, staticRenderFns } from "./pdp-overview.vue?vue&type=template&id=30276cbd&scoped=true"
import script from "./pdp-overview.vue?vue&type=script&lang=js"
export * from "./pdp-overview.vue?vue&type=script&lang=js"
import style0 from "./pdp-overview.vue?vue&type=style&index=0&id=30276cbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30276cbd",
  null
  
)

export default component.exports